import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Alert, AlertTitle, Color } from '@material-ui/lab';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
    maxWidth: "470px",
  },
  rootBottomAlign: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
    maxWidth: "470px",
    top: 'auto',
    right: 'auto',
    bottom: 0,
    left: 0,
    position: 'fixed'
  },
}));

interface ProgressAlertProps {
    alertMessage: string,
    alertSeverity?: Color
}

export const ProgressAlert: React.FC<ProgressAlertProps> = ({alertMessage, alertSeverity}) => {
  const classes = useStyles();
  const [message, setMessage] = React.useState('');
  const [severity, setSeverity] = React.useState<Color>('info');
    
  useEffect(() => {

    // if (alertMessage)
    setMessage(alertMessage);
    if (alertSeverity)
        setSeverity(alertSeverity);

  }, [alertMessage, alertSeverity]);

  return (
    <React.Fragment>
        {message && message !== ''
            ? <div className={classes.root}>
                <Alert variant="filled" severity={ severity }>
                    <AlertTitle>Loading</AlertTitle>
                    {/* <AlertTitle>{ severity === 'success' ? 'Success' : 'Info' }</AlertTitle> */}
                    { message }
                </Alert>
              </div>
            : null
        }
    </React.Fragment>
  );
}
